/**
 * Подбор «Движа» на клиенте (BS §11.4): подписи полос, значки причин,
 * ритм. Сервер отдаёт готовые формулировки — здесь только то, что нужно
 * для отображения и что не зависит от языка данных.
 */
import type { RhythmSlot, Vibe, VibeReason } from '@shared/api/types'
import type { IconName } from '@shared/ui'

export type VibeBand = 'spark' | 'strong' | 'good' | 'new'

/** Открытый список (BS §16.2): неизвестная полоса показывается как «new». */
export function bandOf(vibe: Pick<Vibe, 'band'>): VibeBand {
  return vibe.band === 'spark' || vibe.band === 'strong' || vibe.band === 'good' ? vibe.band : 'new'
}

export const BAND_LABEL: Record<VibeBand, string> = {
  spark: 'Огонь',
  strong: 'Сильное',
  good: 'Есть общее',
  new: 'Новое',
}

const REASON_ICON: Record<VibeReason['kind'], IconName> = {
  shared_interest: 'check-circle',
  related_interest: 'link',
  topic: 'people',
  format: 'smile',
  rhythm: 'clock',
  taste: 'sparkle',
  nearby: 'pin',
  activity: 'activity',
  fresh: 'star',
}

/** Неизвестный вид причины (BS §16.2) — нейтральный значок. */
export function reasonIcon(kind: string): IconName {
  return (REASON_ICON as Record<string, IconName>)[kind] ?? 'info'
}

export const RHYTHM_LABEL: Record<RhythmSlot, string> = {
  mornings: 'Утро',
  daytime: 'День',
  evenings: 'Вечер',
  weekends: 'Выходные',
}

export const RHYTHM_ICON: Record<RhythmSlot, IconName> = {
  mornings: 'sun',
  daytime: 'sun',
  evenings: 'moon',
  weekends: 'star',
}

export const RHYTHM_ORDER: readonly RhythmSlot[] = ['mornings', 'daytime', 'evenings', 'weekends']
